import React from 'react';
import { MapContext } from '@foreflight/webmap/react/withMap';
import { MapLayer } from 'ff/debrief/models';
import { boundsFromPoints } from 'ff/debrief/utils';
import { setMapLayer, toggleAeroLayer } from 'ff/debrief/features/MapSlice';
import { useDebriefDispatch, useDebriefSelector } from 'ff/debrief/hooks';

export const useMapControls = () => {
    const mapContext = React.useContext(MapContext);
    const dispatch = useDebriefDispatch();

    const { layer: currentLayer, aeroLayer } = useDebriefSelector(
        s => s.mapSlice
    );

    const setLayer = (layer: MapLayer) => {
        dispatch(setMapLayer(layer));
    };

    const toggleAero = () => {
        dispatch(toggleAeroLayer());
    };

    const flyToPoints = (points: number[][]) => {
        const bounds = boundsFromPoints(points);
        mapContext.fitBounds(bounds);
    };

    return {
        currentLayer,
        aeroLayer,
        toggleAero,
        setLayer,
        flyToPoints,
        controls: mapContext,
    };
};
